module.exports = __webpack_public_path__ + "static/icons/icon-river-0aeb3825dc61089f5250ca94f2f2635f.svg";